// extracted by mini-css-extract-plugin
export default {"work":"Work_work__bIdNh","textContainer":"Work_textContainer__AHfKi","bgContainer":"Work_bgContainer__gocPM"};